import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router'

export default function ScrollToTop() {
    const { pathname } = useLocation()
    /* Guarda a rota do primeiro render: no carregamento inicial o foco tem de ficar
       no início do documento (senão o link "Saltar para o conteúdo" e a navegação
       ficam inalcançáveis com Tab, que só avança). */
    const rotaAnterior = useRef(pathname)

    useEffect(() => {
        window.scrollTo(0, 0)
        if (rotaAnterior.current === pathname) return
        rotaAnterior.current = pathname
        /* Numa SPA a navegação não muda o foco: para quem usa leitor de ecrã, mudar
           de página não anuncia nada. Mover o foco para o <main> resolve isso. */
        const main = document.getElementById('main')
        if (main) main.focus({ preventScroll: true })
    }, [pathname])

    return null
}
